/* eslint-disable valid-jsdoc */
import socketIO from 'socket.io-client';
import { unstable_batchedUpdates as batchedUpdates } from 'react-dom';
import { logWebSocketEvent } from './logger';

/**
 * 建立並包裝 socket.io client 物件
 * @param {String} url - 連線的 URL
 * @param {Object} options - socket.io 選項
 * @param {Object} loggerConfig - 包含 enable, baseUrl 等 logger 設定
 */
const createSocketIO = (url, options = {}, loggerConfig) => {
	const socket = socketIO.connect(url, options);
	const originalEmit = socket.emit.bind(socket);

	socket.emit = (event, ...args) => {
		if (loggerConfig?.enable) {
			logWebSocketEvent('EMIT', { event, data: args }, loggerConfig);
		}

		return originalEmit(event, ...args);
	};

	// 覆寫 onevent 方法以捕捉所有收到的事件
	const originalOnevent = socket.onevent.bind(socket);

	socket.onevent = msgArray => {
		if (
			loggerConfig?.enable &&
			msgArray?.data &&
			msgArray.data.length > 0
		) {
			const [event, data] = msgArray.data;

			logWebSocketEvent('RECEIVE', { event, data }, loggerConfig);
		}

		// React 16 不會自動 batch socket callback 內的多次 dispatch。將同一個
		// socket event 的同步更新合併成一次 render/commit，避免連續 layout。
		return batchedUpdates(() => originalOnevent(msgArray));
	};

	return socket;
};

function SocketMiddleware(socket) {
	let _socket = socket;
	let _emitters;

	function runReceivers(receivers, store) {
		receivers.forEach(receiver => receiver(_socket, store));
	}

	function runEmitters(emitters) {
		_emitters = emitters.map(emitter => emitter(_socket));
	}

	function redux(store) {
		return next => action => {
			_emitters.forEach(emitter => {
				emitter(store, action);
			});

			next(action);
		};
	}

	return {
		redux,
		runReceivers,
		runEmitters,
	};
}

export {
	createSocketIO,
	SocketMiddleware,
};
